import { render, staticRenderFns } from "./TaxExplain.vue?vue&type=template&id=6dd639b4&scoped=true"
import script from "./TaxExplain.vue?vue&type=script&lang=js"
export * from "./TaxExplain.vue?vue&type=script&lang=js"
import style0 from "./TaxExplain.vue?vue&type=style&index=0&id=6dd639b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd639b4",
  null
  
)

export default component.exports